import { useTranslation } from 'react-i18next'
import styles from './EventPeriod.module.css'

type Props = {
  startDate: string
  endDate: string
  className?: string
}

/**
 * v2キャンペーンの開催期間を表示するコンポーネント
 * */
export function EventPeriod({ startDate, endDate, className }: Props) {
  const { t } = useTranslation()

  return (
    <div className={`${styles.container} ${className ?? ''}`}>
      <p className={styles.text}>
        {t('home.event_period_label', '開催期間：{{start}}〜{{end}}', { start: startDate, end: endDate })}
      </p>
    </div>
  )
}
